/* eslint-disable react/prop-types */
import React, { forwardRef, useEffect, useRef } from 'react';
import { Transformer } from 'react-konva';

// eslint-disable-next-line react/prop-types, react/display-name
const ShapeTransformer = forwardRef((props, _ref) => {
  const trRef = useRef();

  useEffect(() => {
    if (props.isSelected) {
      // we need to attach transformer manually
      trRef.current.nodes([props.shapeRef.current]);
      trRef.current.getLayer().batchDraw();
      // console.log('selected shape: ' + this.state.id);
    };
  }, [props.isSelected]);

  return (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
  );
});

export default React.memo(ShapeTransformer);
